<template>
  <view class="zhibo-wrap">
    <view class="live-box flex flex-a-c" @click="goPlay(item)">
      <img
        v-if="activeIndex == index"
        src="@/assets/H5/play/live-icon.png"
        alt=""
        class="icon-box"
      />
      <img v-else src="@/assets/H5/play/video-0.png" alt="" class="icon-box" />
      <view class="content flex-column">
        <view
          :class="[
            'title van-multi-ellipsis--l3',
            activeIndex == index ? 'active' : '',
          ]"
        >
          {{ item.remark ? item.remark : item.name ? item.name : "" }}
        </view>
        <view
          class="sub-title van-ellipsis mb-10"
          v-if="isSpecial && item.title"
          >{{ item.title }}</view
        >
        <view class="sub-title van-ellipsis" v-if="item.showStartTime"
          >开始时间：{{ item.showStartTime }}</view
        >
        <view class="sub-title van-ellipsis" v-if="item.showEndTime"
          >结束时间：{{ item.showEndTime }}</view
        >
      </view>
    </view>
  </view>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  props: {
    item: Object,
    index: Number,
    activeIndex: Number,
    isSpecial: [Boolean, Number],
  },
  setup(props, { emit }) {
    onMounted(async () => {});
    const goPlay = (item) => {
      let obj = {
        item: item,
        index: props.index,
      };
      emit("clickItem", obj);
    };
    return {
      goPlay,
    };
  },
});
</script>

<style lang="less" scoped>
.zhibo-wrap {
  // .box {
  //   background: #ffffff;
  //   margin-bottom: 16px;
  //   padding: 12px 20px;
  //   border-radius: 4px;
  //   box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  // }
  .live-box {
    display: flex;
    align-items: center;
    // height: 44px;
    padding: 11px 12px;
    background: #f7f7f7;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .icon-box {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .image {
    margin-right: 12px;
  }

  .content {
    overflow: hidden;

    .title {
      font-size: 14px;
      font-weight: 600;
      // color: rgba(0, 0, 0, 0.85);
      color: #222;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .active {
      // color: #6f9fff;
      color: #0f3cc6;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    .sub-title {
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.25);
    }

    .mb-10 {
      margin: 0 0 5px 0;
    }
  }
}
</style>
